import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { PostKbn } from "../../assets/data/Constants";
import { ChatDialog, Chats } from "./components/components";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_CHA003, httpAPI_CHA004 } from "./api/request";

/**
 * SCRC090002 機構への連絡掲示板
 * 契約者と機構職員との間で、任意のチャットを行う。
 * @return SCRC090002
 */
const SCRC090002 = (props: any) => {
  const { open, threadId, onClose } = props;
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [id, setId] = useState<any>("");
  const [chats, setChats] = useState<any>([]);

  /**
   * スレッド詳細一覧参照API実行
   */
  const handleCallApiInit = async () => {
    try {
      const res = await httpAPI_CHA003({
        threadId: threadId,
        contractorNo: state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        const detail = res.noticeBoardThreadList?.map((item) => {
          return {
            chatHistoryNo: item.chatHistoryNo,
            kbn: item.postKbn,
            detail: item.chatDetail,
            fileName: item.fileName,
            fileBase64: item.fileBase64,
            date: item.postDate,
          };
        });

        setId(res.threadId);
        setChats(detail);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    open && handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChange = async (data: any) => {
    // スレッド詳細一覧更新API実行
    try {
      const res = await httpAPI_CHA004({
        threadId: id,
        postKbn: PostKbn["法人"],
        postUserId: state.authInfo?.userId,
        fileName: data.file?.fileName,
        fileBase64: data.file?.fileBase64,
        chatDetail: data.message,
      });

      if (res.resultCd === "I0000") {
        setChats([...chats]);

        setState({
          ...state,
          errorMsgId: "",
        });
        handleCallApiInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC090002">
      <ChatDialog
        open={open}
        onClose={onClose}
        content={<Chats chats={chats} onChange={(e: any) => handleChange(e)} />}
      />
    </Box>
  );
};

export default SCRC090002;
